import React, { useState } from "react";
import {
  Box,
  Card,
  Typography,
  TextField,
  Button,
  Alert,
  IconButton,
  InputAdornment,
} from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { useNavigate } from "react-router-dom";
import { PATHS } from "../../routes/paths";
import AuthLayout from "./authLayout";

const AuthPasswordReset: React.FC = () => {
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isError, setIsError] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const toggleConfirmPasswordVisibility = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    if (password !== confirmPassword) {
      setIsError(true);
    } else {
      setIsError(false);
      navigate(PATHS.AUTH_SIGN_IN);
    }
  };

  return (
    <AuthLayout >
      <Card
        elevation={3}
        sx={{
          margin: "auto",
          padding: 3,
          display: "flex",
          flexDirection: "column",
          maxWidth: "450px",
          width: "100%",
        }}
      >
        <Box
          width={"100%"}
          paddingInline={2}
          display={"flex"}
          flexDirection={"column"}
          gap={1}
        >
          <Typography variant="h5" paddingBlock={2} align="center">
            パスワード設定
          </Typography>
          {isError && (
            <Alert severity="error">パスワードが異なります。</Alert>
          )}
          <form onSubmit={handleSubmit}>
            <Box display={"flex"} flexDirection={"column"} gap={2}>
              <TextField
                type={showPassword ? "text" : "password"}
                fullWidth
                onChange={(e) => setPassword(e.target.value)}
                label="新しいパスワード"
                value={password}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={togglePasswordVisibility}
                        edge="end"
                      >
                        {showPassword ? (
                          <VisibilityOffIcon />
                        ) : (
                          <VisibilityIcon />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
              <TextField
                type={showConfirmPassword ? "text" : "password"}
                fullWidth
                onChange={(e) => setConfirmPassword(e.target.value)}
                label="新しいパスワード(確認用)"
                value={confirmPassword}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={toggleConfirmPasswordVisibility}
                        edge="end"
                      >
                        {showConfirmPassword ? (
                          <VisibilityOffIcon />
                        ) : (
                          <VisibilityIcon />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
              <Button
                sx={{ height: "42px" }}
                type="submit"
                variant="contained"
                fullWidth
              >
                設定
              </Button>
            </Box>
          </form>
          <Button
            sx={{
              marginTop: 2,
              color: "rgba(34, 34, 34, 0.6)",
              "&:hover": {
                color: "rgba(34, 34, 34, 0.8)",
              },
            }}
            onClick={() => navigate(PATHS.AUTH_SIGN_IN)}
            type="button"
            variant="text"
            fullWidth
          >
            キャンセル
          </Button>
        </Box>
      </Card>
    </AuthLayout>
  );
};

export default AuthPasswordReset;
